<template>
  <div>
    <article class="columns box is-radiusless" :class="isShaded">
      <section class="column is-narrow">
        <table class="table" :class="isShaded">
          <tr>
            <th>{{number}}.</th>
          </tr>
        </table>
      </section>
      <section class="column" v-for="(column, i) in columns" :key="i" :class="column._meta_is_narrow">
       <table class="table" :class="isShaded">
        <tr v-for="(value, key, j) in column" :key="j">
          <th v-if="!key.match(/^(_|meta)/g)">{{key}}:</th>
          <td v-if="!key.match(/^(_meta_)/g)">{{value}}</td>
        </tr>
       </table>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    columns: Array,
    number: Number,
  },
  created() {
    console.log(this.columns);
  },
  data() {
    return {
      cols: this.columns,
    };
  },
  computed: {
    isShaded() {
      return this.number % 2 === 0 ? 'has-background-grey-lighter' : '';
    },
  },
};
</script>

<style scoped>
.columns {
  margin: 0;
}
.table td, .table th {
  border: none;
  padding: 0.1em;
}

.box {
  padding: .01rem;
}

.shaded {
  background-color: lightgrey;
}
</style>
